import CryptoJS from "crypto-js";

const SECRET = "GoSehari@2026";

export const encodeJourneyId = (id) => {
    return encodeURIComponent(
        CryptoJS.AES.encrypt(String(id), SECRET).toString()
    );
};

export const decodeJourneyId = (value) => {
    try {
        const bytes = CryptoJS.AES.decrypt(
            decodeURIComponent(value),
            SECRET
        );
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
        return null;
    }
};